module.exports = __webpack_public_path__ + "img/nomap.714b5b73.png";